import type { Map as MapboxMap } from 'mapbox-gl';
import { type RefObject, useMemo } from 'react';
import type { IPointOfInterest } from '@/types/api';
import { PLACE_PIN_MIN_ZOOM, type PlaceLinkPoint } from '../utils/placeLink';
import { pointOfInterestPlace } from '../utils/placePayload';
import { usePlaceLocationLink } from './usePlaceLink';
import { useSelectedPlacePin } from './useSelectedPlacePin';

/**
 * Shows the place a location is linked to: a dotted line from the location, and a pin on the
 * place that hides while the map is zoomed out. Either end missing shows nothing. The workspace
 * card and the deal card draw it the same way.
 */
export function useLinkedPlace(
  map: RefObject<MapboxMap | null>,
  location: PlaceLinkPoint | null | undefined,
  place: IPointOfInterest | null | undefined,
): void {
  const linked = place ?? null;
  usePlaceLocationLink(map, linked ? (location ?? null) : null, linked);
  const pin = useMemo(() => (linked ? pointOfInterestPlace(linked) : null), [linked]);
  useSelectedPlacePin(map, pin, PLACE_PIN_MIN_ZOOM);
}
